import { api } from "..";

import { BettingRules, BettingRulesResponse } from "./getBettingRules";

export interface SaveBettingRulesParams {
  rules: BettingRules;
  targetUsername?: string;
  asTargetOwn?: boolean;
}

export async function saveBettingRules(
  data: SaveBettingRulesParams
): Promise<BettingRulesResponse> {
  const res = await api.client.post(`/betting-rules`, data);
  return res.data;
}
